import React from 'react'
import {
  createTheme,
  makeStyles,
  MuiThemeProvider
} from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import styles from 'assets/jss/style-component/components/customInputStyle.js'
import classNames from 'classnames'
import { GridItem } from 'components'
import PropTypes from 'prop-types'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { CircularProgress } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import ReactTooltip from 'react-tooltip'

const theme = createTheme({
  overrides: {
    MuiInputBase: {
      root: {
        // backgroundColor: "#fff  !important",
        fontSize: 'small  !important'
      }
    },
    MuiAutocomplete: {
      root: {
        //backgroundColor: "#fff  !important",
        fontSize: 'small  !important'
      },
      inputRoot: {
        padding: '0px !important'
      },
      popper: {},
      option: {
        fontSize: 'small  !important',
        backgroundColor: '#fff  !important',
        '&[data-focus="true"]': {
          backgroundColor: '#0681b5 !important'
        }
      }
    },
    PrivateNotchedOutline: {
      legendLabelled: {},
      legendNotched: {
        maxWidth: '0px !important'
      }
    }
  }
})
const useStyles = makeStyles(styles)

function CustomSelectFormik({
  id,
  formik,
  labelProps,
  style,
  fieldName,
  labelText,
  options,
  sm,
  md,
  value,
  loading,
  error,
  success,
  blanco,
  variant,
  disabled,
  required,
  helperText
}) {
  const classes = useStyles()
  const variantField = 'standard'
  const handleValueChange = (event, newValue) => {
    formik.setFieldValue(fieldName, newValue || null)
  }

  const getOptionLabel = option => {
    if (!option || Object.keys(option).length === 0) {
      return ''
    }
    return option.nombre || ''
  }
  const getOptionSelected = (option, value) => {
    return option.option === value.option
  }

  function getErrorForField(formik, fieldPath) {
    const keys = fieldPath.split('.')
    let errorObject = formik.errors
    for (const key of keys) {
      errorObject = errorObject?.[key]
      if (!errorObject) {
        return null
      }
    }

    return errorObject
  }
  const fieldPath = fieldName
  const fieldError = getErrorForField(formik, fieldPath)

  const shouldShowError = formik.touched[fieldName] && fieldError

  const labelClasses = classNames({
    [' ' + classes.labelRootError]: shouldShowError ? fieldError : '',
    [' ' + classes.labelRootSuccess]: success && !fieldError,
    [' ' + classes.labelRootBlanco]: blanco && !success && !fieldError
  })

  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <MuiThemeProvider theme={theme}>
        {labelText !== undefined ? (
          <InputLabel
            className={classes.labelRoot + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        ) : null}
        <Autocomplete
          data-tip={helperText}
          value={value}
          style={style}
          onChange={handleValueChange}
          options={options}
          getOptionLabel={getOptionLabel}
          getOptionSelected={getOptionSelected}
          loading={loading}
          disabled={disabled}
          className={classes.labelRoot + labelClasses}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              size="small"
              label=""
              variant={variantField}
              error={shouldShowError}
              className={classes.labelRoot + labelClasses}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
        />
        {shouldShowError && (
          <div style={{ color: 'red' }} className="formik-error">
            {fieldError}
          </div>
        )}{' '}
        <ReactTooltip />
      </MuiThemeProvider>
    </GridItem>
  )
}

CustomSelectFormik.propTypes = {
  formik: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  error: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.number,
      nombre: PropTypes.string
    })
  ).isRequired,
  md: PropTypes.number,
  loading: PropTypes.bool
}

export default CustomSelectFormik
